import {computed, onMounted} from "vue";
import {storeToRefs} from "pinia";

import {useSearchStore} from "../store/search";

export const useSearchFilters = () => {
    const searchStore = useSearchStore();

    let {searchParams} = storeToRefs(searchStore);


    const country = computed({get: () => searchParams.value.country, set: (value) => {
            searchParams.value.country = value;
            searchParams.value.state = 0;
            searchParams.value.city = 0;
        }
    });

    const state = computed({get: () => searchParams.value.state, set: (value) => {
            searchParams.value.state = value;
            searchParams.value.city = 0;
        }
    });
    const city = computed({get: () => searchParams.value.city, set: (value) => searchParams.value.city = value });

    const keyword = computed({get: () => searchParams.value.keyword, set: (value) => searchParams.value.keyword = value });
    const status = computed({get: () => searchParams.value.status, set: (value) => searchParams.value.status = value });
    const rentPer = computed({get: () => searchParams.value.rent_amount_per, set: (value) => searchParams.value.rent_amount_per = value });
    const propertyFinalizing = computed({get: () => searchParams.value.property_finalizing, set: (value) => searchParams.value.property_finalizing = value });
    const selectedFeatures = computed(() => searchParams.value.features);

    const price = computed(() => searchStore.range('price'));
    const rent = computed(() => searchStore.range('rent'));
    const beds = computed(() => searchStore.range('bedrooms'));
    const baths = computed(() => searchStore.range('bathrooms'));
    const area = computed(() => searchStore.range('area'));
    const rooms = computed(() => searchStore.range('rooms'));
    const garages = computed(() => searchStore.range('garages'));
    const units = computed(() => searchStore.range('units'));
    const floor_numbers = computed(() => searchStore.range('floor_number'));
    const year_built = computed(() => searchStore.range('year_built'));

    const onRangeChange = (field, data) => {
        searchStore.setSearchRange({field: field, value: {min: data[0], max: data[1]}});
    }

    const onSelectFeature = val => {
        searchStore.setSearchFeature(val);
    }

    const onUnselectFeature = val => {
        searchStore.removeSearchFeature(val);
    }

    return {
        country,
        state,
        city,
        keyword,
        status,
        rentPer,
        baths,
        price,
        rent,
        beds,
        area,
        rooms,
        garages,
        units,
        floor_numbers,
        year_built,
        propertyFinalizing,
        selectedFeatures,
        onRangeChange,
        onSelectFeature,
        onUnselectFeature
    };
}
